export async function setCanonicalFromApi(routePath) {
    try {
        console.log("routePath =>", routePath);

        const response = await fetch(`http://localhost:5000/api/v1/ContentManagement/CanonicalLinks/Find?url=${routePath}`);
        const data = await response.json();

        console.log("Canonical Response =>", data.Value);

        // حذف تگ canonical قبلی اگر وجود دارد
        let oldLink = document.querySelector("link[rel='canonical']");
        if (oldLink) oldLink.remove();

        // اگر data.Value وجود داشت، تگ جدید بساز
        if (data.Value && data.Value.CanonicalUrl) {
            const link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', data.Value.CanonicalUrl);
            document.head.appendChild(link);
        } else {
            console.log('canonical not found in response, tag removed if existed.');
        }

    } catch (err) {
        console.warn('canonical not set due to error:', err);
    }
}

